export default {
    room: { Unseen: 0, Details: [] }
}
